import { render, staticRenderFns } from "./GynecoHistory.vue?vue&type=template&id=0a9d5104"
import script from "./GynecoHistory.vue?vue&type=script&lang=js"
export * from "./GynecoHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports